'use client'

import { Title } from '@mantine/core'

interface SkuTitleProps {
    skuName: string
    wellnessSku?: boolean
    order?: 1 | 2 | 3 | 4 | 5 | 6
}

export function SkuTitle({ skuName, wellnessSku = false, order = 1 }: SkuTitleProps) {
    return (
        <Title
            order={order}
            fz={{ base: wellnessSku ? 36 : 48, md: 48 }}
            fw={{ base: wellnessSku ? 500 : 'var(--weight-display-large, 400)', md: 500 }}
            lh={{ base: wellnessSku ? '50px' : '110%', md: 1.1 }}
            mb={{ base: 0, md: 'sm' }}
            c={{
                base: wellnessSku ? 'var(--GM-Text-Black, #181818)' : 'var(--Foreground-fg-primary, #1F1E1D)',
                md: 'text-black',
            }}
            lts={{ base: '-2%', md: '-1px' }}
            style={{ alignSelf: 'stretch', maxWidth: '495px' }}
        >
            {skuName}
        </Title>
    )
}
